/**
 * Global Webhook Configuration - ReaperDiscs
 *
 * This file provides consistent webhook configuration for all cart-related scripts.
 * Update the values below to match your setup.
 */

window.CART_WEBHOOK_CONFIG = {
  webhookUrl: 'https://shopify.infinitediscs.com/webhook/theme_webhook.php',
  apiKey: 'c74ce262f891de4a58216cac04b52eb939b404141152e43fe8776cac0a019435',
  shop: 'reaper-disc-supply.myshopify.com',
  enableLogging: true
};

// Also set DAWN_WEBHOOK_CONFIG for compatibility with the interceptor
window.DAWN_WEBHOOK_CONFIG = {
  webhookUrl: 'https://shopify.infinitediscs.com/webhook/theme_webhook.php',
  apiKey: 'c74ce262f891de4a58216cac04b52eb939b404141152e43fe8776cac0a019435',
  shop: 'reaper-disc-supply.myshopify.com',
  enabled: true,
  debug: true,
  cartHoldExpiration: 30,
  events: {
    cart: {
      add: true,
      update: true,
      remove: true,
      clear: true,
      note: true
    },
    order: {
      create: true,
      update: true,
      cancel: true
    }
  }
};

console.log('[Webhook Config] ReaperDiscs configuration loaded:', {
  shop: window.CART_WEBHOOK_CONFIG.shop,
  hasApiKey: !!window.CART_WEBHOOK_CONFIG.apiKey,
  webhookUrl: window.CART_WEBHOOK_CONFIG.webhookUrl,
  loggingEnabled: window.CART_WEBHOOK_CONFIG.enableLogging,
  dawnConfig: window.DAWN_WEBHOOK_CONFIG
});
